import { motion } from "framer-motion";
import { IMAGES } from "../data/site";

const LABELS = [
  "Tandoori Plate",
  "Lunch Special",
  "Crispy Dosa",
  "Curry Spread",
  "Street Snacks",
  "Samosa Chaat",
  "Naan Basket",
  "Royal Thali",
  "Mango Lassi",
];

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-brand-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14 max-w-3xl"
        >
          <span className="font-heading uppercase text-[11px] tracking-[0.3em] font-bold text-brand-red">
            · The Visual Feast
          </span>
          <h2 className="mt-3 font-display uppercase text-5xl md:text-6xl lg:text-7xl leading-[0.9] text-brand-charcoal">
            Sights from<br />
            our <span className="text-brand-red italic">kitchen.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {IMAGES.gallery.map((src, i) => {
            const tall = i % 3 === 1;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.7, delay: i * 0.05 }}
                className={`group relative overflow-hidden rounded-2xl md:rounded-3xl cursor-pointer ${
                  tall ? "row-span-2 aspect-[3/5]" : "aspect-square"
                }`}
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={src}
                  alt={LABELS[i] || "Red Chilly's dish"}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000 ease-[cubic-bezier(0.33,1,0.68,1)]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/85 via-brand-charcoal/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-5 left-5 right-5 translate-y-3 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
                  <span className="font-heading uppercase text-[10px] tracking-[0.25em] font-bold text-brand-mustard">
                    · Red Chilly's
                  </span>
                  <h4 className="font-display uppercase text-2xl text-brand-cream leading-none mt-1">
                    {LABELS[i] || "Signature Dish"}
                  </h4>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
